
import { ajax } from "@/assets/js/ajax";
export function getlist(data) {     //回款金额列表
  return ajax({
    url: 'credit/loan/lists',
    type: 'get',
    data: data
  })
}
export function payeeAdd(data) {     //添加回款
  return ajax({
    url: 'credit/payee/add',
    type: 'post',
    data: data,
    contentType: 'application/json'
  })
}
export function payeeEdit(data) {     //修改回款
  return ajax({
    url: 'credit/payee/edit',
    type: 'post',
    data: data,
    contentType: 'application/json'
  })
}
export function payeeDetails(data) {     //修改回款
  return ajax({
    url: 'credit/loan/info',
    type: 'get',
    data: data,
  })
}
export function loanAdd(data) {      //新增分期
  return ajax({
    url: "credit/loan/add",
    type: "post",
    data: data,
    contentType: "application/json"
  })
}
export function loanEdit(data) {      //新增分期
  return ajax({
    url: "credit/loan/edit",
    type: "post",
    data: data,
    contentType: "application/json"
  })
}
export function loancement(data) {      //新增分期
  return ajax({
    url: "credit/loan/enforcement",
    type: "post",
    data: data,
    contentType: "application/json"
  })
}

export function loadHis(data) {      //分期审核列表
  return ajax({
    url: "credit/loan/audit",
    type: "get",
    data: data
  })
}

export function loadFuture(data) {      //即将还款分期列表
  return ajax({
    url: "credit/loan/future_pay_List",
    type: "get",
    data: data
  })
}

export function loadOverdue(data) {      //逾期分期列表
  return ajax({
    url: "credit/loan/overdue",
    type: "get",
    data: data
  })
}

export function ngetlist(data) {
  return ajax({
    url: "credit/loan/index",
    data: data,
    type: 'get'
  })
}
export function loanDetails(data) {
  return ajax({
    url: 'credit/loan/read',
    data: data,
    type: 'get'
  })
}

export function payList(data) {
  return ajax({
    url: "credit/payee/payeeList",
    data: data,
    type: "get"
  })
}

export function getLoanList(data) {
  return ajax({
    url: 'credit/loan/periodByCause',
    data: data,
    type: "get"
  })
}